import { Environment } from '../models/AuthConfig.model';

export const CLOUD_REFERENCE_LINKS = {
  IOT_SUPPORT_URL: {
    STAGING: 'https://console.stage.iot.trimblecloud.com/home',
    PRODUCTION: 'https://console.iot.trimblecloud.com/home',
    LOCAL: 'https://console.stage.iot.trimblecloud.com/home',
  },
  TRANSACTION_EMAIL_URL: {
    STAGING: 'https://email.stage.utilities.trimblecloud.com/home',
    PRODUCTION: 'https://email.utilities.trimblecloud.com/home',
    LOCAL: 'https://email.stage.utilities.trimblecloud.com/home',
  },
  PROFILE_URL: {
    STAGING: 'https://stage.myprofile.trimblecloud.com/home',
    PRODUCTION: 'https://myprofile.trimble.com/home',
    LOCAL: 'https://stage.myprofile.trimblecloud.com/home',
  },
} as const;

export const COMPANY_REFERENCE_LINKS = {
  PRIVACY_NOTICE_URL:
    'https://www.trimble.com/en/our-commitment/responsible-business/data-privacy-and-security/data-privacy-center/privacy-notice',
  TERMS_OF_USE_URL: 'https://www.trimble.com/en/legal/terms-and-conditions/terms-of-use',
  CA_NOTICE_AT_COLLECTION_URL:
    'https://www.trimble.com/en/our-commitment/responsible-business/data-privacy-and-security/data-privacy-center/ca-residents-notice-at-Collection',
  YOUR_PRIVACY_CHOICES_US_URL:
    'https://www.trimble.com/en/our-commitment/responsible-business/data-privacy-and-security/data-privacy-center/your-privacy-choices',
} as const;

type Url = keyof typeof CLOUD_REFERENCE_LINKS;
// must carry only first layer key
export const getEnvUrl = <T extends Url>(url: T, environment: Environment): string => {
  return CLOUD_REFERENCE_LINKS[url][environment];
};
